module.exports = __webpack_public_path__ + "dingbeauty-build/img/calender_arrow_right.da44c3b1.svg";